import { render, staticRenderFns } from "./LandLordName.vue?vue&type=template&id=5b7718ee"
import script from "./LandLordName.vue?vue&type=script&lang=js"
export * from "./LandLordName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports